import React from 'react';

import { ScrollUpButton } from './component';
import { useScrollUpButton } from './hook/useScrollUpButton';
import { ETestIds } from '../../../constants/testIds';
import { useTracking } from '../../../utils/tracking/useTracking';

export const ScrollUpButtonContainer: React.FC = () => {
  const { trackScrollToCalculatorButton, trackScrollToOffersButton } = useTracking();
  const { buttonRef, scrollToBlock, type } = useScrollUpButton();

  const config = {
    filters: {
      testId: ETestIds.ScrollUpButtonFilters,
      trackScrollTo: trackScrollToCalculatorButton,
    },
    up: {
      testId: ETestIds.ScrollUpButtonUp,
      trackScrollTo: trackScrollToOffersButton,
    },
  };

  const getTestID = (type: keyof typeof config) => {
    return config[type].testId;
  };

  const getTrackScrollTo = (type: keyof typeof config) => {
    return config[type].trackScrollTo;
  };

  const testId = getTestID(type);
  const trackScrollTo = getTrackScrollTo(type);

  const handleScrollToBlock = () => {
    scrollToBlock();
    trackScrollTo();
  };

  return <ScrollUpButton testId={testId} iconType={type} onClick={handleScrollToBlock} ref={buttonRef} />;
};

ScrollUpButtonContainer.displayName = 'ScrollUpButtonContainer';
